import {
    ColorValueRestDto,
    CssDimensionRestDto,
    EyebrowRestDto,
    TextColorValueRestDto
} from "@/api/pharma-cms-content-page/models";
import {EyebrowStyleEnum} from "@/api/enums/eyebrow-style-enum";
import {BarWidthEnum} from "@/api/enums/bar-width-enum";
import {FontWeightEnum} from "@/api/enums/font-weight-enum";
import {MarginBottomEnum} from "@/api/enums/margin-bottom-enum";
import {TextTransformEnum} from "@/api/enums/text-transform-enum";
import {ColorValueRestDtoModel} from "@/models/api/ColorValueRestDtoModel";
import {TextColorValueRestDtoModel} from "@/models/api/TextColorValueRestDtoModel";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";

export class EyebrowRestDtoModel implements EyebrowRestDto {
    style_code: EyebrowStyleEnum;
    text?: string | null;
    color?: ColorValueRestDto | null;
    text_color?: TextColorValueRestDto | null;
    font_weight_code?: FontWeightEnum | null;
    text_transform_code?: TextTransformEnum | null;
    margin_bottom_code?: MarginBottomEnum | null;
    letter_spacing?: CssDimensionRestDto | null;
    bar_thickness?: CssDimensionRestDto | null;
    bar_width_code?: BarWidthEnum | null;

    constructor(style_code: EyebrowStyleEnum) {
        this.style_code = style_code;
    }

    static createWithDefaults(): EyebrowRestDtoModel {
        const model: EyebrowRestDtoModel = new this(EyebrowStyleEnum.TAG);
        model.color = ColorValueRestDtoModel.createWithDefaults();
        model.text_color = TextColorValueRestDtoModel.createWithDefaults();
        return model;
    }

    static cloneFrom(source: EyebrowRestDto): EyebrowRestDtoModel {
        const clone: EyebrowRestDtoModel = new this(source.style_code);

        clone.text = source.text;
        clone.font_weight_code = source.font_weight_code;
        clone.text_transform_code = source.text_transform_code;
        clone.margin_bottom_code = source.margin_bottom_code;
        clone.bar_width_code = source.bar_width_code;
        clone.letter_spacing = source.letter_spacing
            ? CssDimensionRestDtoModel.cloneFrom(source.letter_spacing)
            : null;
        clone.bar_thickness = source.bar_thickness
            ? CssDimensionRestDtoModel.cloneFrom(source.bar_thickness)
            : null;
        clone.color = source.color
            ? ColorValueRestDtoModel.cloneFrom(source.color)
            : ColorValueRestDtoModel.createWithDefaults();
        clone.text_color = source.text_color
            ? TextColorValueRestDtoModel.cloneFrom(source.text_color)
            : TextColorValueRestDtoModel.createWithDefaults();

        return clone;
    }
}
